import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import { i18n } from './locales'
import { installBrowserLogger } from './services/browser-logger'
import './styles/tokens.css'
import './styles/global.css'

installBrowserLogger()
createApp(App).use(createPinia()).use(i18n).mount('#app')
